import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { apiAction } from '../../store/generalSlice';
import ObjectViewer from '../Common/ObjectViewer';
import Spinner from '../../layout/Spinner';
import CreateAdSet from './CreateAdSet';

const Campaign = () => {
  const dispatch = useDispatch();
  const { account_id, campaign_id } = useParams();
  const { campaign, campaignChangeName } = useSelector((state) => state.general);
  const [newCampaignName, setNewCampaignName] = useState('');
  const [changeCampaignClicked, setChangeCampaignClicked] = useState(false);

  const adsetColumns = [
    {
      field: 'id',
      headerName: 'id',
      width: 200,
      renderCell: (params) => {
        return (
          <a href={`/adset/${account_id}/${params.row.id}`} target='_blank' rel='noreferrer'>
            {params.value}
          </a>
        );
      },
    },
    {
      field: 'name',
      headerName: 'name',
      width: 550,
    },
    {
      field: 'status',
      headerName: 'status',
      width: 200,
    },
  ];

  useEffect(() => {
    // dispatch(
    //   apiAction({ reduxField: 'allAccountData', route: 'accountDashboard/getAllAccountData', accountId: account_id })
    // );
    dispatch(
      apiAction({
        reduxField: 'campaign',
        route: 'accountDashboard/getCampaignById',
        accountId: account_id,
        campaignId: campaign_id,
      })
    );
  }, [dispatch, account_id, campaign_id]);
  console.log({ campaign, campaignChangeName });
  return (
    <>
      <div>
        <Link className='btn btn-outline-dark' to={`/AccountDashboard/${account_id}`}>
          Back to Account
        </Link>
      </div>
      <div className='mt-4 mb-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
          <h3>Campaign Overview</h3>
        </div>
        <div className='row d-flex justify-content-center pt-lg-0 mt-4'>
          <h5>
            Campaign Data from Facebook <span className='text-primary'>getCampaignById(campaignId, token)</span>
          </h5>
        </div>
        <div className='row d-flex justify-content-center pt-lg-0 mt-4'>
          {changeCampaignClicked ? (
            <>
              <div className='col-md-8 d-flex justify-content-center'>
                <input
                  type='text'
                  className='form-control'
                  defaultValue={newCampaignName}
                  style={{ textAlign: 'center' }}
                  onChange={(e) => setNewCampaignName(e.target.value)}
                />
              </div>
              <div className='col-md-8 d-flex justify-content-center mt-2'>
                <button
                  className='btn btn-success'
                  onClick={() => {
                    setChangeCampaignClicked(false);
                    dispatch(
                      apiAction({
                        reduxField: 'campaignChangeName',
                        route: 'accountDashboard/changeCampaignOrAdsetName',
                        accountId: account_id,
                        id: campaign_id,
                        newName: newCampaignName,
                      })
                    );
                  }}
                >
                  Save
                </button>
              </div>
            </>
          ) : (
            <>
              <button
                className='btn btn-outline-primary'
                onClick={() => {
                  setChangeCampaignClicked(true);
                  setNewCampaignName(campaign.name);
                }}
              >
                Change Campaign Name
              </button>
            </>
          )}
        </div>
        <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
          {campaign?.id ? <ObjectViewer data={campaign} /> : <Spinner />}
        </div>
        <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
          <div data-aos='fade-up' data-aos-delay='200'>
            {Array.isArray(campaign?.adsets?.data) ? (
              <div className='border p-2' data-aos='fade-up' data-aos-delay='200'>
                <Box style={{ height: 600, width: '100%' }}>
                  <DataGrid
                    rows={campaign.adsets?.data}
                    columns={adsetColumns}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    //   checkboxSelection
                    disableSelectionOnClick
                  />
                </Box>
              </div>
            ) : (
              <Spinner />
            )}
          </div>
        </div>
        <CreateAdSet accountId={account_id} campaignId={campaign_id} />
      </div>
    </>
  );
};

export default Campaign;
